import React, {useEffect, useMemo, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {
    LOGIN_MODAL, ONE_TIME_PASSWORD_MODAL,
    openModal,
    SELECT_QUANTITY_MODAL,
    updateModalRes
} from "@arboxappv4/shared/src/redux/modalManagerSlice";
import {maskEmail, maskPhone, onLinkClicked} from "../../../helpers/functions";
import CustomModal from "../../../components/UI/CustomModal";
import {
    Btn,
    FlexColumnSection,
    FlexDiv,
    GreyTextClickable,
    Header,
    SmallLogo,
    Wrapper
} from "../../../styles/globalStyles";
import {Formik} from "formik";
import {t} from "i18next";
import FormInput from "../../../components/UI/FormInput";
import * as yup from "yup";
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import {useDispatch, useSelector} from "react-redux";
import {otpLogin, resetError} from "@arboxappv4/shared/src/redux/authSlice";
import {apiAction} from "@arboxappv4/shared/src/helpers/HTTP";
import {HEADER_SIGN_IN_CALLER, projectTypeMainSlice} from "@arboxappv4/shared/src/helpers/constants";

const OneTimePassword = (props) => {
    const { isOpen, onClose, email, otpId, type, phone, standAlone, isVerify, userId, isTokenVerify, caller } = props; //userid if kiosk only
    const project_type = useSelector(state => state.project.project_type)
    const box = useSelector(state => state[projectTypeMainSlice[project_type]].box)
    const error = useSelector(state => state.auth?.error)
    const user = useSelector(state => state.user?.data)
    const [counting, setCounting] = useState(0);
    const [otpIdForReset, setOtpIdForReset] = useState(otpId);
    const [verifyError, setVerifyError] = useState(null);
    const validationSchema = useMemo(() => yup.object().shape({code: yup.string().matches(/^[0-9]+$/, t('digits-only-field')).required()}), []);
    const navigate = useNavigate();
    const {isMobile} = useScreenSize();
    const dispatch = useDispatch()

    useEffect(() => {
        if(user) {
            if(window.location.pathname === '/register') {
                onLinkClicked('/membership', navigate)
            } else if(caller !== HEADER_SIGN_IN_CALLER) {
                dispatch(updateModalRes({modalName: ONE_TIME_PASSWORD_MODAL, res: true})) //trigger login success from inside the flow (not from header)
            } else {
                window.location.reload() //if from header - reload page
            }
            onClose()
        }
    }, [user]);

    const goBackToLogin = () => {
        dispatch(resetError())
        onClose()
        // if(!standAlone) dispatch(openModal({modalName: LOGIN_MODAL, props: {email: email}}))
    }

    const goHome = () => {
        onLinkClicked('/', navigate)
        onClose()
    }

    const resend = async () => {
        const params = {
            type: type ?? 'email',
            value: email ?? phone,
            isVerify,
            check_format: true, //does not matter in kiosk token verify
            user_id: userId ?? null //only in kiosk token verify
        }
        const otpId = await apiAction(`mfa`, 'post', params);
        setOtpIdForReset(otpId)
        let timeLeft = 30;
        setCounting(timeLeft)
        const countdown = () => {
            if (timeLeft === -1) {
                clearTimeout(timerId);
                setCounting(0)
            } else {
                setCounting(timeLeft)
                timeLeft--;
            }
        }
        const timerId = setInterval(countdown, 1000);
    }

    const submit = (values) => {
        const params = {
            type: type ?? 'email',
            value: email ?? phone,
            code: values.code,
            id: otpIdForReset,
        }
        if(isVerify || isTokenVerify) {
            verifyCode(params)
        } else {
            dispatch(otpLogin(params))
        }
    }

    const verifyCode = async (params) => {
        try {
            const utpID = await apiAction('site/verifyPhone', 'post', params); //route name is phone but it can be for email as well
            dispatch(updateModalRes({modalName: ONE_TIME_PASSWORD_MODAL, res: utpID}))
            onClose()
        } catch (error) {
            setVerifyError(error.error.messageToUser)
        }
    }

    return (
        <CustomModal open={isOpen} onClose={goBackToLogin} width={isMobile ? '100%' : '450px'}>
            <Wrapper>
                <Formik initialValues={{ code: ''}} validationSchema={validationSchema} onSubmit={submit}>
                    {({
                        values,
                        errors,
                        touched,
                        setFieldValue,
                        handleSubmit
                    }) => (
                        <FlexColumnSection gap={'20px'}>
                            {isMobile && <SmallLogo mobile={isMobile} src={box?.cloudinary_image} alt="logo" onClick={goHome}/>}
                            <FlexColumnSection gap={'5px'} flex={'none'}>
                                <Header>{isTokenVerify ? t('token-verify-header') : t('otp-header')}</Header>
                                <div>{t('otp-subheader')}</div>
                                {!isTokenVerify && <div style={{fontWeight: 600}}>{email ?? phone}</div>}
                                {isTokenVerify && <div style={{fontWeight: 600}}>{email ? maskEmail(email) : maskPhone(phone)}</div>}
                            </FlexColumnSection>
                            <FlexColumnSection gap={'10px'} flex={'none'}>
                                <FormInput value={values.code} error={(touched.code && errors.code) ? errors.code : ((error || verifyError) ? t((error || verifyError) === 'CodeHasExpired' ? 'CodeHasExpired' : 'OTPInvalid') : null)} onChangeCallback={(val) => setFieldValue('code', val)} inputMode={'numeric'}/>
                                <span style={{fontSize: '14px'}}>{`${t(type === 'sms' ? 'resend-sms-label' : 'resend-label')} `}
                                    {counting === 0 ?
                                        <span onClick={resend} style={{fontSize: '14px', textDecoration: 'underline', cursor: 'pointer'}}>{t('resend')}</span>
                                        :
                                        <span style={{fontSize: '14px'}}>{t('resend-count-down', {sec: counting})}</span>
                                    }
                                </span>
                            </FlexColumnSection>
                            <FlexDiv dir={isMobile ? 'column' : 'row'} gap={'15px'}>
                                <Btn type={'primary'} onClick={handleSubmit} width={isMobile ? '100%' : null}>{t(type === 'sms' ? 'verify' : 'continue')}</Btn>
                            </FlexDiv>
                            {!standAlone && <GreyTextClickable onClick={goBackToLogin}>{t('back-to-login')}</GreyTextClickable>}
                        </FlexColumnSection>
                    )}
                </Formik>
            </Wrapper>
        </CustomModal>
    );
};

export default OneTimePassword;